import { TFunction } from 'i18next';
import { AdditionalFieldTypes } from 'enums/onboarding/crm';
import { AdditionalFieldFormItemWithNullableIdModel } from 'components/Forms/FormComponents/AdditionalField';
import {
  FieldValidationRule,
  generatePlaceholderForDatePicker,
  generatePlaceholderForInputField,
  generatePlaceholderForDropdownField,
  generateSimpleRequiredOptionalPlaceholder,
} from '@ui';

export function getPlaceholderForInputField(
  validationRules: FieldValidationRule[],
  isRequired: boolean,
  t: TFunction<string | string[], undefined>,
) {
  const newValidationRules: FieldValidationRule[] = [...validationRules];
  if (isRequired) {
    newValidationRules.unshift({ type: 'required' });
  }
  return generatePlaceholderForInputField(newValidationRules, t);
}

export function getPlaceholderForAmountField(
  validationRules: FieldValidationRule[],
  isRequired: boolean,
  t: TFunction<string | string[], undefined>,
) {
  const newValidationRules: FieldValidationRule[] = [...validationRules];
  if (isRequired) {
    newValidationRules.unshift({ type: 'required' });
  }
  return generateSimpleRequiredOptionalPlaceholder(newValidationRules, t);
}

export function getPlaceholderForSelect(
  validationRules: FieldValidationRule[],
  isRequired: boolean,
  isMultiple: boolean,
  t: TFunction<string | string[], undefined>,
) {
  const newValidationRules: FieldValidationRule[] = [...validationRules];
  if (isRequired) {
    newValidationRules.unshift({ type: 'required' });
  }
  return generatePlaceholderForDropdownField(isMultiple, newValidationRules, t);
}

export function getPlaceholderForDatePicker(
  validationRules: FieldValidationRule[],
  isRequired: boolean,
  t: TFunction<string | string[], undefined>,
) {
  const newValidationRules: FieldValidationRule[] = [...validationRules];
  if (isRequired) {
    newValidationRules.unshift({ type: 'required' });
  }
  return generatePlaceholderForDatePicker(newValidationRules, t);
}

export function getPlaceholderForNumberField(
  validationRules: FieldValidationRule[],
  isRequired: boolean,
  t: TFunction<string | string[], undefined>,
) {
  const newValidationRules: FieldValidationRule[] = [...validationRules];
  if (isRequired) {
    newValidationRules.unshift({ type: 'required' });
  }
  return generateSimpleRequiredOptionalPlaceholder(newValidationRules, t);
}

export function generateFieldPlaceholderForAdditionalField(
  validationRules: FieldValidationRule[],
  additionalField: AdditionalFieldFormItemWithNullableIdModel,
  t: TFunction<string | string[], undefined>,
) {
  const isRequired = additionalField.options.onboardingRequired;

  switch (additionalField.type) {
    case AdditionalFieldTypes.String:
      return getPlaceholderForInputField(validationRules, isRequired, t);

    case AdditionalFieldTypes.Select:
      return getPlaceholderForSelect(validationRules, isRequired, false, t);

    case AdditionalFieldTypes.Date:
      return getPlaceholderForDatePicker(validationRules, isRequired, t);

    case AdditionalFieldTypes.Number:
    case AdditionalFieldTypes.Percentage:
      return getPlaceholderForNumberField(validationRules, isRequired, t);

    default:
      return '';
  }
}
